import { ROUTES_BY_NAME } from '@retailer-platform/dashboard/route-patterns'
import { buildRouteCatalog } from './routeCatalog'

export const DOMAIN_ROUTES = buildRouteCatalog(
  import.meta.glob<Record<string, string>>('../../../domains/*/src/routing/routes.ts', {
    eager: true,
    import: 'routes',
  }),
  ROUTES_BY_NAME
)
